import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import VueMeta from "vue-meta";
import Notifications from "vue-notification";
import VueProgress from "vue-progress-path";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from "bootstrap-vue";
// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from "bootstrap-vue";
// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from "bootstrap-vue";
// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from "bootstrap-vue";
// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
import vueDebounce from "vue-debounce";
import Carousel3d from "vue-carousel-3d";
import { BFormFile } from "bootstrap-vue";
import UUID from "vue-uuid";
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-0NBBTMVD40" },
  pageTrackerScreenviewEnabled: true,
  appName: 'eGalleria-Customer-Frontend',
}, router);
Vue.use(VueSmoothScroll)

Bugsnag.start({
  apiKey: '1332498840e3994adb4af59c1684dbed',
  plugins: [new BugsnagPluginVue()]
})

Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(UUID);
Vue.use(Carousel3d);
Vue.use(LayoutPlugin);
Vue.use(ModalPlugin);
Vue.use(CardPlugin);
Vue.use(VBScrollspyPlugin);
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueProgress);
Vue.use(vueDebounce);
Vue.component("b-form-file", BFormFile);

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue)

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../public/assets/css/styles.css";

import { track_user } from "./utils/helper.js";

router.beforeEach((to, from, next) => {
  track_user(this, `page movement from ${from.fullPath} => ${to.fullPath}`);
  var token = localStorage.getItem("token");
  if (token !== null) {
    let expiry_raw = localStorage.getItem("expiry");
    var expiry = new Date(expiry_raw);
    var now = new Date();
    let distance = expiry - now;
    if (distance <= 0 || expiry_raw == null) {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("expiry");
      router.push("/logout/");
    } else {
      store.commit("setIsAuthenticated", true);
      if (store.state.profile == null) {
        store.dispatch("getProfile").then((res) => {
          store.commit("setProfile", res);
        });
      }
    }
  }

  if (to.meta.requiresAuth) {
    if (store.getters.isAuthenticated) {
      next();
    } else {
      next({
        path: "/login/",
      });
    }
  } else {
    next();
  }
});

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
